export class DonutChartDataItemModel {
    public name: string;
    public y: number;
    public color: string;
}
